import { InsModDate } from './date.model';

export class Conto extends InsModDate {
    id!: number;
    codice!: string;
    mastro!: number;
    conto!: number;
    sottoconto!: number;
    descrizione!: string;
    gruppo!: string;
    tipogruppo!: number;
    tipo!: string;
    note?: string;
}

export enum ContoType {
    MASTRO = 'mastro',
    CONTO = 'conto',
    SOTTOCONTO = 'sottoconto'
}

export enum ContoGruppo {
    COSTI = 'C',
    RICARVI = 'R',
    ATTIVITA = 'A',
    PASSIVITA = 'P',
    ONERI = 'O',
    GIROCONTI = 'G'
}